/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Fade,
    Chip,
    Tabs,
    Tab,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,        
    InputAdornment,     
    FormControl,         
    InputLabel,         
    Select,             
    MenuItem as SelectMenuItem  
} from '@mui/material';
import {
    LocationOn,
    Add,
    NavigateNext,
    NavigateBefore,
    List as ListIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Block as BlockIcon,
    CheckCircle as ActivateIcon,
    Search as SearchIcon,   
    Clear as ClearIcon  
} from '@mui/icons-material';
import { useSite } from 'hooks/api/terminology/site/useSite';
import { useDistrict } from 'hooks/api/terminology/district/useDistrict';
import { useProvince } from 'hooks/api/terminology/province/useProvince';
import { PaginationButton, StyledTableContainer, globalColor } from '../../ConstantColors';
import { logger } from 'utils/environment/log';
import Swal from 'sweetalert2';
import AddEditSite from './add';
import {
    ClampedText,
    CodeText,
    ConfigurationActionMenu,
    ConfigurationPagination,
    ConfigurationStatusChip,
    stickyActionCellSx,
    stickyActionHeadSx,
    tableSx
} from '../components/ConfigurationTable';

const SearchSection = ({ searchTerm, setSearchTerm, searchField, setSearchField, onClearSearch, loading }) => {
    const searchFields = [
        { value: 'name', label: 'Site Name' },
        { value: 'district.name', label: 'District' },
        { value: 'district.province.name', label: 'Province' },
        { value: 'address', label: 'Address' },
        { value: 'postalCode', label: 'Postal Code' }
    ];

    return (
        <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Search Field</InputLabel>
                <Select value={searchField} label="Search Field" onChange={(e) => setSearchField(e.target.value)} disabled={loading}>
                    {searchFields.map((field) => (
                        <SelectMenuItem key={field.value} value={field.value}>
                            {field.label}
                        </SelectMenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                size="small"
                placeholder={`Search by ${searchFields.find((f) => f.value === searchField)?.label || 'Site Name'}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={loading}
                sx={{ flexGrow: 1, maxWidth: 400 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={onClearSearch} disabled={loading}>
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

const Site = () => {
    const [activeTab, setActiveTab] = useState(0);
    
    // States for pagination and data
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(5);

    // Search states
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('name');

    // Hooks
    const { listSite, updateSite, deleteSite, sites } = useSite();
    const { listDistrict, districts } = useDistrict();
    const { listProvince, provinces } = useProvince();

    // Additional states
    const [editingSite, setEditingSite] = useState(null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [siteToDelete, setSiteToDelete] = useState(null);
    const [toggleConfirmOpen, setToggleConfirmOpen] = useState(false);
    const [siteToToggle, setSiteToToggle] = useState(null);
    const [loading, setLoading] = useState(true);

    // Initial data fetch
    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            await Promise.all([listSite(0, 100), listDistrict(0, 100), listProvince(0, 100)]);
        } catch (error) {
            logger.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Helper function to get nested object value
    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((current, key) => {
            return current && current[key] !== undefined ? current[key] : null;
        }, obj);
    };

    // Filter sites based on search
    const getFilteredSites = () => {
        if (!searchTerm.trim()) {
            return sites;
        }

        const searchLower = searchTerm.toLowerCase().trim();
        return sites.filter((site) => {
            const fieldValue = getNestedValue(site, searchField);
            if (fieldValue === null || fieldValue === undefined) {
                return false;
            }
            return String(fieldValue).toLowerCase().includes(searchLower);
        });
    };

    const filteredSites = getFilteredSites();

    const handleClearSearch = () => {
        setSearchTerm('');
        setPage(0);
    };

    const handleEditClick = (site) => {
        setEditingSite(site);
        setActiveTab(1);
    };

    const handleAddNew = () => {
        setEditingSite(null);
        setActiveTab(1);
    };

    const handleDeleteClick = (site) => {
        setSiteToDelete(site);
        setDeleteConfirmOpen(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await deleteSite(siteToDelete.id);
            await fetchInitialData();
            setDeleteConfirmOpen(false);
            setSiteToDelete(null);
            Swal.fire({
                icon: 'success',
                title: 'Site Deleted',
                text: 'The site has been successfully deleted.',
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            logger.error('Error deleting site:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to delete the site. Please try again.'
            });
        }
    };

    const handleDeleteCancel = () => {
        setDeleteConfirmOpen(false);
        setSiteToDelete(null);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            setEditingSite(null);
        }
    };

    const handleToggleActive = async (site) => {
        setSiteToToggle(site);
        setToggleConfirmOpen(true);
    };

    const handleToggleConfirm = async () => {
        try {
            const updatedSite = { ...siteToToggle, isActive: !siteToToggle.isActive };
            await updateSite(siteToToggle.id, updatedSite);
            await fetchInitialData();
            setToggleConfirmOpen(false);
            setSiteToToggle(null);
            Swal.fire({
                icon: 'success',
                title: siteToToggle.isActive ? 'Site Deactivated' : 'Site Activated',
                text: `The site has been successfully ${siteToToggle.isActive ? 'deactivated' : 'activated'}.`,
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            logger.error('Error toggling site status:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to update site status. Please try again.'
            });
        }
    };

    const handleToggleCancel = () => {
        setToggleConfirmOpen(false);
        setSiteToToggle(null);
    };

    const handleSiteSubmitted = () => {
        fetchInitialData();
        setActiveTab(0);
        setEditingSite(null);
    };

    const renderSitesList = () => (
        <Box sx={{ mt: 4 }}>
            <SearchSection
                searchTerm={searchTerm}
                setSearchTerm={(value) => {
                    setSearchTerm(value);
                    setPage(0);
                }}
                searchField={searchField}
                setSearchField={setSearchField}
                onClearSearch={handleClearSearch}
                loading={loading}
            />

            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    {searchTerm ? (
                        <>
                            Showing {filteredSites.length} of {sites.length} sites
                            {filteredSites.length > 0 && ` matching "${searchTerm}"`}
                        </>
                    ) : (
                        <>Total: {sites.length} sites</>
                    )}
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={handleAddNew}
                    sx={{
                        backgroundColor: globalColor,
                        '&:hover': {
                            backgroundColor: globalColor,
                            opacity: 0.9
                        }
                    }}
                >
                    Add New Site
                </Button>
            </Box>

            <Fade in timeout={1000}>
                <StyledTableContainer component={Paper}>
                    <Table size="small" sx={tableSx(980)}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: 104 }}>Site ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell sx={{ width: 92 }}>Code</TableCell>
                                <TableCell sx={{ width: 148 }}>District</TableCell>
                                <TableCell sx={{ width: 148 }}>Province</TableCell>
                                <TableCell sx={{ width: 150 }}>Address</TableCell>
                                <TableCell sx={{ width: 92 }}>Status</TableCell>
                                <TableCell align="center" sx={stickyActionHeadSx}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredSites.length > 0 ? (
                                filteredSites.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((site) => (
                                    <TableRow key={site.id}>
                                        <TableCell><CodeText>{site.id}</CodeText></TableCell>
                                        <TableCell><ClampedText>{site.name}</ClampedText></TableCell>
                                        <TableCell><CodeText>{site.code}</CodeText></TableCell>
                                        <TableCell><ClampedText maxWidth={148}>{site.district?.name}</ClampedText></TableCell>
                                        <TableCell><ClampedText maxWidth={148}>{site.district?.province?.name}</ClampedText></TableCell>
                                        <TableCell><ClampedText maxWidth={150}>{site.address}</ClampedText></TableCell>
                                        <TableCell>
                                            <ConfigurationStatusChip active={site.isActive} />
                                        </TableCell>
                                        <TableCell align="center" sx={stickyActionCellSx}>
                                            <ConfigurationActionMenu
                                                label={site.name}
                                                actions={[
                                                    { label: 'Edit', icon: EditIcon, onClick: () => handleEditClick(site) },
                                                    {
                                                        label: site.isActive ? 'Deactivate' : 'Activate',
                                                        icon: site.isActive ? BlockIcon : ActivateIcon,
                                                        color: site.isActive ? '#b54708' : '#25643b',
                                                        onClick: () => handleToggleActive(site)
                                                    },
                                                    { label: 'Delete', icon: DeleteIcon, color: '#d92d20', onClick: () => handleDeleteClick(site) }
                                                ]}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        <Box sx={{ py: 4 }}>
                                            <Typography variant="body1" color="text.secondary">
                                                {searchTerm ? (
                                                    <>
                                                        No sites found matching "{searchTerm}" in {searchField}
                                                        <Box sx={{ mt: 2 }}>
                                                            <Typography
                                                                variant="body2"
                                                                color="primary"
                                                                sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                onClick={handleClearSearch}
                                                            >
                                                                Clear search to view all sites
                                                            </Typography>
                                                        </Box>
                                                    </>
                                                ) : (
                                                    'No sites available'
                                                )}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <ConfigurationPagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        total={filteredSites.length}
                        onPageChange={setPage}
                    />
                </StyledTableContainer>
            </Fade>
        </Box>
    );

    const renderToggleDialog = () => (
        <Dialog open={toggleConfirmOpen} onClose={handleToggleCancel}>
            <DialogTitle>
                {siteToToggle?.isActive ? 'Deactivate Site' : 'Activate Site'}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to {siteToToggle?.isActive ? 'deactivate' : 'activate'} the site "{siteToToggle?.name}"?
                    {siteToToggle?.isActive && ' This will make the site unavailable for use.'}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleToggleCancel}>Cancel</Button>
                <Button 
                    onClick={handleToggleConfirm} 
                    color={siteToToggle?.isActive ? 'warning' : 'success'} 
                    variant="contained"
                >
                    {siteToToggle?.isActive ? 'Deactivate' : 'Activate'}
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderDeleteDialog = () => (
        <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel}>
            <DialogTitle>Confirm Site Deletion</DialogTitle>
            <DialogContent>
                <Typography>Are you sure you want to delete the site "{siteToDelete?.name}"? This action cannot be undone.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDeleteCancel}>Cancel</Button>
                <Button onClick={handleDeleteConfirm} color="error" variant="contained">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '1rem',
                            textTransform: 'none'
                        }
                    }}
                >
                    <Tab icon={<ListIcon />} iconPosition="start" label="Sites List" />
                    <Tab icon={<Add />} iconPosition="start" label={editingSite ? 'Edit Site' : 'Add New Site'} />
                </Tabs>
            </Box>

            {activeTab === 0 ? (
                renderSitesList()
            ) : (
                <AddEditSite
                    editingSite={editingSite}
                    onSiteSubmitted={handleSiteSubmitted}
                    districts={districts}
                    provinces={provinces}
                />
            )}
            
            {renderToggleDialog()}
            {renderDeleteDialog()}
        </Box>
    );
};

export default Site;
